import React, { useState, useEffect } from "react";
import { Spinner, Form } from "react-bootstrap";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";

const SelectMunicipio = ({ formik, field, update, disabled }) => {
  const [listaMunicipios, setListaMunicipios] = useState([]);
  const [sqUf, setSqUf] = useState("");
  const [consultar, setConsultar] = useState(true);
  const [showErro, setshowErro] = useState(false);
  const [messageErro, setMessageErro] = useState("");

  const { request, data, errors, isLoading } = useApiClient();

  useEffect(() => {
    if (update) {
      setConsultar(true);
      setSqUf(formik.values.sequencialUf);
    } else {
      setConsultar(false);
      setSqUf("");
      setListaMunicipios([]);
    }
  }, [formik.values.sequencialUf, update]);

  useEffect(() => {
    if (consultar) {
      request(apiRoutes.fiscalizacao.parametrizacao.listaMunicipios, { sequencialUf: sqUf });
    }
  }, [request, consultar, sqUf]);

  useEffect(() => {
    if (data?.result) {
      setListaMunicipios(data.result);
      setConsultar(false);
    }

    if (errors) {
      setMessageErro(errors.message);
      setshowErro(true);
    }
  }, [data, errors]);

  return (
    <>
      {showErro && (
        <>
          <br />
          <div className="alert alert-danger" role="alert">
            {messageErro}
          </div>
        </>
      )}
      {isLoading ? (
        <span>
          <Spinner animation="border" role="status" />
          &nbsp;Carregando ...
        </span>
      ) : (
        <>
          <Form.Control
            as="select"
            id={field}
            name={field}
            disabled={disabled || !update}
            value={formik.values[field]}
            onChange={formik.handleChange}
            isInvalid={formik.touched[field] && formik.errors[field]}
          >
            <option key="0" value="">
              Selecione
            </option>
            {listaMunicipios.map((item) => (
              <option key={item.sequencialMunicipio} value={item.sequencialMunicipio}>
                {item.nomeMunicipio}
              </option>
            ))}
          </Form.Control>
          {formik.touched[field] && formik.errors[field] && (
            <Form.Control.Feedback type="invalid">{formik.errors[field]}</Form.Control.Feedback>
          )}
        </>
      )}
    </>
  );
};

export default SelectMunicipio;
